<template>
	<div>
		<BModal v-model="createHabitModalVisible" hide-footer centered :title="title">
			<healthy-habits-form inModal @habitCreated="(habitId) => onNewHabitCreated(habitId)" :habitDescription="title"/>
		</BModal>
		<PatientPanelServiceBlock visible :clickOnceEnabled="false" :id="_id" :title="title" :description="!isFoodMicrohabitType ? $i18nHelpers.normalize(description) : null" :action="() => onClickMicrohabitBlock()" :backgroundImg="backgroundImage" style="cursor: pointer" class="taller-neu-card" :actionable="isFoodMicrohabitType" :toggleableMobileDescription="isFoodMicrohabitType">
			<template v-slot:icon>
				<img :src="img" :width="$uiHelpers.isXlDevice ? '100' : '75'" class="microhabits-icon"/>
			</template>
			<template v-slot:absolute-items>
				<BIconHeartFill v-if="showHeartIcon" class="position-absolute heart-microhabit" variant="primary" v-b-tooltip.hover="$t('patient.microhabits.added-to-favourites', { habitType: microhabitI18nName({ plural: true })})" @click.stop="deletePatientMicrohabit"></BIconHeartFill>
			</template>
			<!-- <span v-if="categories.length > 1"> -->
		  <template v-slot:footer>
				<span class="d-block mt-3">
					<!-- <b-modal :id="modalId" :ref="modalId" :title="$t('patient.microhabits.select-category')" hide-footer centered body-class="text-center" v-if="categories.length > 0">
						<b-row class="neu-cards-ctn landing-cnt mt-5" cols="1" cols-xl="2">
							<PatientMicrohabitBlock v-for="category in categories" :key="category.id" :id="category.id" :patientMicrohabit="patientMicrohabit" :categories="[category]" :title="$i18nHelpers.normalize(category.name)" :img="category.icon" noBackgroundImage></PatientMicrohabitBlock>
						</b-row>
					</b-modal> -->
					<!-- <span class="category-badges d-block" v-if="categories.length > 0">
						<b-badge v-for="category in categories" :key="category.id" variant="secondary" class="d-inline-block" style="cursor: pointer" @click="() => { goToMicrohabit(categories.id, patientMicrohabit.microhabit.id) }">{{ $i18nHelpers.normalize(category.name) }}</b-badge>
					</span> -->
					<span class="d-block secondary-badges">
						<b-badge variant="success" class="d-inline-block" @click.stop="setMicrohabitAchievementStatus(false)" v-if="patientMicrohabit.achieved" v-b-tooltip.hover="achievedTooltipText">✔ {{ achievedBadgeText }}</b-badge>
						<b-badge variant="info" class="d-inline-block" @click.stop="setMicrohabitAchievementStatus(true)" v-else><BIconPlusCircle></BIconPlusCircle> {{ notAchievedBadgeText }}</b-badge>
						<!-- <b-badge variant="primary" class="d-inline-block" v-if="patientMicrohabit.habitId" @click.stop="$helpers.goToHabits()">
							<BIconBellFill v-b-tooltip.hover="$t('patient.microhabits.reminder')"></BIconBellFill>
						</b-badge> -->
						<base-icon class="d-inline-block" @click.stop="onMyGoalsClick" blue :width="21" :height="21" src="/static-appopensalud/img/icons/morillas-svg-icons/primary/goals.svg" v-b-tooltip.hover="myGoalsTooltipText"></base-icon>
						<!-- <b-badge variant="primary" class="d-inline-block" v-else @click.stop="() => { createHabitModalVisible = true }">
							
						</b-badge> -->
					</span>
				</span>
			</template>
		</PatientPanelServiceBlock>
	</div>
</template>

<script>
import { BBadge, BIconBell, BIconBellFill, BModal } from 'bootstrap-vue'
import PatientPanelServiceBlock from '@/components/PatientPanelServiceBlock'
import microhabitsMixin from '@/mixins/microhabits.mixin'
import { firstLetterUppercase } from '@/helpers/string.helpers'
import HealthyHabitsForm from '@/components/views/healthy-habits/HealthyHabitsForm'

export default {
	name: 'PatientMicrohabitBlock',
	mixins: [microhabitsMixin],
	components: {
		BModal,
		BBadge,
		PatientPanelServiceBlock,
		BIconBell,
		BIconBellFill,
		HealthyHabitsForm
	},
	data () {
		return {
			createHabitModalVisible: false
		}
	},
	props: {
		patientMicrohabit: {
			type: Object,
			required: true
		},
		categories: {
			type: Array,
			required: false,
			default () {
				if (this.mainCategory) {
					return [this.mainCategory]
				}
				return this.patientMicrohabit.microhabit.categories ? this.patientMicrohabit.microhabit.categories : []
			}
		},
		title: {
			type: String,
			required: false,
			default () {
				return this.$i18nHelpers.normalize(this.patientMicrohabit.microhabit.name)
			}
		},
		img: {
			type: [String, Object, undefined],
			required: false,
			default () {
				if (this.patientMicrohabit.microhabit.images) return this.patientMicrohabit.microhabit.images[0]
				if (this.patientMicrohabit.microhabit.icon) return this.patientMicrohabit.microhabit.icon
				return this.DEFAULT_MICROHABIT_IMAGE
			}
		},
		noBackgroundImage: {
			type: Boolean,
			required: false,
			default: false
		},
		mainCategory: {
			type: Object,
			required: false,
			default: null
		},
		showHeartIcon: {
			type: Boolean,
			required: false,
			default: false
		},
		description: {
			type: [Object, String],
			required: false,
			default () {
				return this.patientMicrohabit.microhabit.categories[0].description || this.patientMicrohabit.microhabit.defaultDescription
			}
		}
	},
	computed: {
		backgroundImage () {
			return !this.noBackgroundImage ? this.patientMicrohabit.microhabit.images[0] : null
		},
		modalId () {
			return `modal${this.patientMicrohabit.id.replaceAll('-', '')}`
		},
/* 		habitsIconBellComponent () {
			return this.patientMicrohabit.habitId ? 'BIconBellFill' : 'BIconBell'
		},
		habitsBellIconTooltip () {
			return this.patientMicrohabit.habitId ? this.$t('patient.microhabits.remove-habit') : this.$t('patient.microhabits.create-habit')
		}, */
		_id () {
			return `${this.patientMicrohabit.microhabit.id}-${this.$helpers.generateGuid()}`
		},
		achievedTooltipText () {
			if (this.patientMicrohabit.achieved) {
				return this.isFoodMicrohabitType ? this.$t('patient.foods.remove-from-diet') : this.$t('patient.microhabits.remove-from-achieved')
			} else {
				return this.isFoodMicrohabitType ? this.$t('patient.foods.add-to-diet') : this.$t('patient.microhabits.add-to-achieved')
			}
		},
		achievedBadgeText () {
			return this.isFoodMicrohabitType ? this.$t('patient.foods.in-diet') : this.$t('patient.microhabits.added-to-achieved')
		},
		notAchievedBadgeText () {
			return this.isFoodMicrohabitType ? this.$t('patient.foods.add-to-diet') : this.$t('patient.microhabits.add-to-achieved')
		},
		achievedSuccessText () {
			return this.isFoodMicrohabitType ? this.$t('patient.foods.patient-food-add-diet-success') : this.$t('patient.microhabits.patient-microhabit-achieved-success')
		},
		notAchievedSuccessText () {
			return this.isFoodMicrohabitType ? this.$t('patient.foods.patient-food-remove-diet-success') : this.$t('patient.microhabits.patient-microhabit-remove-diet-success')
		},
		myGoalsTooltipText () {
			return this.patientMicrohabit.habitId ? this.$t('patient-panel.my-goals') : this.$t('patient.microhabits.create-habit')
		}
	},
	methods: {
		onClickMicrohabitBlock () {
			if (!this.isFoodMicrohabitType) {
				return
			}
			if (this.mainCategory && this.mainCategory.id) {
				this.goToMicrohabit(this.mainCategory.id, this.patientMicrohabit.microhabit.id)
			} else if (this.categories.length === 1) {
				this.goToMicrohabit(this.categories[0].id, this.patientMicrohabit.microhabit.id)
			} else {
				this.$bvModal.show(this.modalId)
			}
		},
		getCategoryIcon (category) {
			return category.icon
		},
		setMicrohabitAchievementStatus (achieved) {
			this.patientMicrohabit.achieved = achieved
			this.microhabitRepository.updatePatientMicrohabit(this.patientMicrohabit).then(() => {
				this.$store.dispatch('showAlert', { text: achieved ? this.achievedSuccessText : this.notAchievedSuccessText, variant: 'success' })
			})
		},
		deletePatientMicrohabit () {
			this.microhabitRepository.deletePatientMicrohabit(this.patientMicrohabit.id).then(() => {
				this.$store.dispatch('showAlert', { text: this.$t('patient.microhabits.removed-from-favourites', { typeName: firstLetterUppercase(this.microhabitI18nName({ plural: false })) }), variant: 'success' })
				this.$emit('deleted')
			})
		},
		onNewHabitCreated (habitId) {
			this.patientMicrohabit.habitId = habitId
			this.microhabitRepository.updatePatientMicrohabit(this.patientMicrohabit).then(() => {
				this.$store.dispatch('showAlert', {text: this.$t('patient.foods.habit-created-success-on-modify'), variant: 'success'})
				this.createHabitModalVisible = false
			})
		},
		onMyGoalsClick () {
			if (this.patientMicrohabit.habitId) {
				this.$helpers.goToHabits()
			} else {
				this.createHabitModalVisible = true
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../../../static-appopensalud/css/webapp/foods-section.scss';

.category-badges {
	.badge:not(:first-child) {
		margin-left: 0.25rem;
	}
}

/* .bell-icon {
	font-size: 1.05rem;
} */

.secondary-badges {
	margin-top: .25rem;


	.badge {
		transition: all 0.2s;
		&:hover {
			cursor: pointer;
			transition: all 0.2s;
			border-color: $white;
		}
	}
}

@mixin absolute-icon() {
	position: absolute;
	top: 1.5rem;
	right: 3rem;
	cursor: pointer;
	font-size: 1.15rem;
}

.heart-microhabit {
	@include absolute-icon;

	@include media(mobile, tablets) {
		top: 15px;
		right: 20px;
		font-size: 1.5rem;
	}
}

.microhabits-icon {
	border-radius: $border-radius;
	width: 110px;

	@include media(mobile, tablets) {
		margin-bottom: 1rem;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/microhabits/PatientMicrohabitBlock.vue